<template>
  <app-page
    :title="`Rehire ${employee ? employee.full_name : 'Employee'}`"
    :error="error"
    :previous="[
      { label: 'Employees', to: { name: 'employees' } },
      {
        label: employee ? employee.full_name : 'Employee',
        to: { name: 'employee', params: { employeeId: $route.params.employeeId } },
      },
    ]"
    icon="user-plus"
  >
    <app-loading :loading="loading" />
    <template v-if="!loading && !saved">
      <!-- Guards the page itself, not just the button, so pasting the URL for an employee
           whose termination came from the integration can't reach the action. -->
      <sme-alert v-if="unavailableReason" level="warning">{{ unavailableReason }}</sme-alert>
      <template v-else>
        <sme-alert level="warning">
          You are about to rehire {{ employee.full_name }}. This clears their termination and restores their access to
          flexible pay.
        </sme-alert>
        <page-sub-footer>
          <b-button data-testid="rehire-button" @click="onRehire" variant="primary" :disabled="saving">
            <b-spinner v-if="saving" class="mr-2" small />
            {{ saving ? 'Rehiring...' : 'Rehire employee' }}
          </b-button>
        </page-sub-footer>
      </template>
    </template>
    <sme-alert v-if="saved" level="good">
      <p>
        <strong>{{ employee.full_name }} has been rehired.</strong>
      </p>
      <p v-if="newStateLabel">The employee has been reactivated back to {{ newStateLabel }}.</p>
      <p v-if="newState === EMPLOYEE_STATE.PENDING">
        Access to flexible pay will be restored once banking has been updated in your HR system.
      </p>
    </sme-alert>
  </app-page>
</template>

<script>
import ApiClient from '@/ApiClient';
import AppLoading from '@/components/AppLoading.vue';
import AppPage from '@/components/AppPage.vue';
import PageSubFooter from '@/components/PageSubFooter.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import { toTitleCase } from '@/utils/common';
import { EMPLOYEE_STATE, getRehireUnavailableReason } from '@/utils/Employee';

export default {
  name: 'EmployeeRehire',
  components: { AppLoading, AppPage, PageSubFooter, SmeAlert },
  data() {
    return {
      EMPLOYEE_STATE,
      loading: true,
      saving: false,
      saved: false,
      error: undefined,
      employee: undefined,
      newState: undefined,
    };
  },
  computed: {
    newStateLabel() {
      return toTitleCase(this.newState);
    },
    unavailableReason() {
      return getRehireUnavailableReason(this.employee);
    },
  },
  methods: {
    async onRehire() {
      this.saving = true;

      try {
        const result = await ApiClient.employeeReverseUnenrolment(this.employee.employee_id);
        this.newState = result?.new_state;
        this.saved = true;
      } catch (error) {
        this.error = error.message;
      }

      this.saving = false;
    },
    loadData() {
      this.loading = true;
      ApiClient.getEmployee(this.$route.params.employeeId).then(
        employee => {
          this.employee = employee;
          this.loading = false;
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
